import React from 'react';
import { CheckCircle, Circle, TrendingUp } from 'lucide-react';
import { WeekProgress } from '../types';
import './WeeklySummary.css';

interface WeeklySummaryProps {
  weekProgress: WeekProgress;
}

export const WeeklySummary: React.FC<WeeklySummaryProps> = ({ weekProgress }) => {
  const completionPercentage = Math.round((weekProgress.tasksCompleted / weekProgress.totalTasks) * 100);
  
  return (
    <div className="weekly-summary">
      <div className="summary-header">
        <h3>Week {weekProgress.weekNumber} Summary</h3>
        <TrendingUp size={20} style={{ color: '#4CAF50' }} />
      </div>
      
      <div className="summary-stats">
        <div className="summary-stat">
          <div className="stat-progress">
            <div className="circular-progress">
              <svg viewBox="0 0 36 36">
                <path
                  d="M18 2.0845
                    a 15.9155 15.9155 0 0 1 0 31.831
                    a 15.9155 15.9155 0 0 1 0 -31.831"
                  fill="none"
                  stroke="#E0E0E0"
                  strokeWidth="3"
                />
                <path
                  d="M18 2.0845
                    a 15.9155 15.9155 0 0 1 0 31.831
                    a 15.9155 15.9155 0 0 1 0 -31.831"
                  fill="none"
                  stroke="#4CAF50"
                  strokeWidth="3"
                  strokeDasharray={`${completionPercentage}, 100`}
                />
              </svg>
              <div className="percentage">{completionPercentage}%</div>
            </div>
          </div>
          <div className="stat-info">
            <div className="stat-title">Overall Progress</div>
            <div className="stat-subtitle">{weekProgress.tasksCompleted}/{weekProgress.totalTasks} tasks</div>
          </div>
        </div>
        
        <div className="summary-details">
          <div className="detail-item">
            <span className="detail-label">Problems Solved:</span>
            <span className="detail-value">{weekProgress.problemsSolved}/35</span>
          </div>
          
          <div className="detail-item">
            <span className="detail-label">Mock Interviews:</span>
            <span className="detail-value">{weekProgress.mockInterviewsCompleted}/1</span>
          </div>
          
          <div className="topics-covered">
            <div className="detail-label">Topics Covered:</div>
            <div className="topic-list">
              {weekProgress.topicsCovered.map((topic, index) => (
                <div key={index} className="topic-item">
                  {weekProgress.topicsCovered.includes(topic) ? (
                    <CheckCircle size={16} style={{ color: '#4CAF50' }} />
                  ) : (
                    <Circle size={16} style={{ color: '#E0E0E0' }} />
                  )}
                  <span>{topic}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};